const config = {
  env: '',
  app_token: 'pc_mis_token'
};
export default config;
